import Cookies from 'js-cookie'

// 本地存储用户登录相关

export function getToken() {
    return Cookies.get('userToken', { expires: 1, domain: 'jsdaoboinc.com' });
}

export function setToken(token) {
    Cookies.set('userToken', token, { expires: 1, domain: '.jsdaoboinc.com' });
}

export function setUserId(id) {
    Cookies.set('userId', id, { expires: 1, domain: '.jsdaoboinc.com' });
}

export function getUserId() {
    return Cookies.get('userId', { expires: 1, domain: '.jsdaoboinc.com' });
}

export function setUserName(name) {
    localStorage.setItem('userName', name);
}

export function getUserName() {
    return localStorage.getItem('userName');
}

export function removeUserInfo() {
    Cookies.remove('userToken');
    Cookies.remove('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userFunction');
}

// 用户可用功能
export function setUserFunction(userFunction) {
    localStorage.setItem('userFunction', userFunction);
}

export function getUserFunction() {
    return localStorage.getItem('userFunction');
}


// WEBPACK FOOTER //
// ./src/utils/auth.js